/* =================================================================
   PILATIX Support — Quick Help accordion animation
   Smooth animated open/close with eased velocity. Same pattern as
   pltx2-faq.js: cancels native <details> snap, animates height +
   opacity via CSS transitions, cleans inline styles when done.
   ================================================================= */
(function () {
  if (typeof document === 'undefined') return;

  function init() {
    const items = document.querySelectorAll('.pltx2-support-quickhelp__item');
    if (!items.length) return;

    const reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const EASE_OPEN = 'cubic-bezier(0.16, 1, 0.3, 1)';     // expo-out — fast start, soft land
    const EASE_CLOSE = 'cubic-bezier(0.32, 0, 0.32, 1)';   // smooth ease-in-out, less abrupt
    const D_OPEN = reduceMotion ? 0 : 400;
    const D_CLOSE = reduceMotion ? 0 : 380;

    function animate(el, fromH, toH, duration, ease, done) {
      if (duration === 0) { if (done) done(); return; }
      if (el.__cleanup) el.__cleanup(true);

      el.style.overflow = 'hidden';
      el.style.height = fromH + 'px';
      el.style.opacity = fromH === 0 ? '0' : '1';
      el.style.willChange = 'height, opacity';
      void el.offsetHeight;  // force reflow so the start state commits

      el.style.transition =
        'height ' + duration + 'ms ' + ease +
        ', opacity ' + Math.round(duration * 0.7) + 'ms ' + ease;
      el.style.height = toH + 'px';
      el.style.opacity = toH === 0 ? '0' : '1';

      let finished = false;
      function cleanup(aborted) {
        if (finished) return;
        finished = true;
        el.removeEventListener('transitionend', onEnd);
        clearTimeout(safetyTimer);
        el.style.transition = '';
        el.style.height = '';
        el.style.opacity = '';
        el.style.overflow = '';
        el.style.willChange = '';
        el.__cleanup = null;
        if (!aborted && done) done();
      }
      function onEnd(e) {
        if (e.propertyName !== 'height' || e.target !== el) return;
        cleanup(false);
      }
      el.addEventListener('transitionend', onEnd);
      const safetyTimer = setTimeout(function () { cleanup(false); }, duration + 100);
      el.__cleanup = cleanup;
    }

    items.forEach(function (item) {
      const summary = item.querySelector('summary');
      const answer = item.querySelector('.pltx2-support-quickhelp__a');
      if (!summary || !answer) return;

      let animating = false;

      summary.addEventListener('click', function (e) {
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        if (animating) return;
        animating = true;

        if (item.open) {
          // CLOSE
          const startH = answer.scrollHeight;
          animate(answer, startH, 0, D_CLOSE, EASE_CLOSE, function () {
            answer.style.height = '0px';
            answer.style.overflow = 'hidden';
            answer.style.opacity = '0';
            item.open = false;
            requestAnimationFrame(function () {
              answer.style.height = '';
              answer.style.overflow = '';
              answer.style.opacity = '';
              animating = false;
            });
          });
        } else {
          // OPEN
          item.open = true;
          const endH = answer.scrollHeight;
          animate(answer, 0, endH, D_OPEN, EASE_OPEN, function () { animating = false; });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
